import {ListInterface, ListItemInterface} from './lists-http-intterfaces';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LystTypeFilter} from 'src/app/enums/list-enums';
import {GeneralHttpHelperService} from '../../helpers/general-http-helper.service';
import {environment} from '../../../../environments/environment';

const BASE_V2_URL = `${environment.API_ENDPOINT_V2}`;

const LISTS_API_ROUTES = {
  POST_LIST: 'lysts',
  POST_LIST_IMAGE: 'lysts/:listId/add_image',
  GET_SINGLE_LIST: 'lysts/',
  GET_PUBLIC_SINGLE_LIST: 'share/lyst/:listId',
  GET_PUBLIC_SINGLE_LIST_ITEMS: 'share/lyst_items/:listId',
  GET_SINGLE_LIST_ITEMS: 'items/lysts/',
  GET_SINGLE_ITEM: 'items/',
};

@Injectable({
  providedIn: 'root'
})

export class ListsHttpService {

  constructor(private httpClient: HttpClient, private generalHelperService: GeneralHttpHelperService) {
  }

  // V2 ROUTES -> START

  private getFavoriteItemsV2Req(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Observable<any> {
    const params = [];

    if (search) {
      params.push(`search=${encodeURIComponent(search)}`);
    }
    if (perPage) {
      params.push(`per_page=${perPage}`);
    }
    if (pageNumber) {
      params.push(`page=${pageNumber}`);
    }

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return this.httpClient.get<any[]>(`${BASE_V2_URL}lysts/type/favorite-items${queryString}`);
  }

  getFavoriteItemsV2(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getFavoriteItemsV2Req(pageNumber, search, perPage).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data),
          });
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  private getFavoriteListersV2Req(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Observable<any> {
    const params = [];

    if (search) {
      params.push(`search=${encodeURIComponent(search)}`);
    }
    if (perPage) {
      params.push(`per_page=${perPage}`);
    }
    if (pageNumber) {
      params.push(`page=${pageNumber}`);
    }

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return this.httpClient.get<any[]>(`${BASE_V2_URL}lysts/type/favorite-listers${queryString}`);
  }

  getFavoriteListersV2(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getFavoriteListersV2Req(pageNumber, search, perPage).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data),
          });
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  private getFavoriteLystsV2Req(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Observable<any> {
    const params = [];

    if (search) {
      params.push(`search=${encodeURIComponent(search)}`);
    }
    if (perPage) {
      params.push(`per_page=${perPage}`);
    }
    if (pageNumber) {
      params.push(`page=${pageNumber}`);
    }

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return this.httpClient.get<any[]>(`${BASE_V2_URL}lysts/type/favorite-lysts${queryString}`);
  }

  getFavoriteLystsV2(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getFavoriteLystsV2Req(pageNumber, search, perPage).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data),
          });
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  private getFollowedListersV2Req(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Observable<any> {
    const params = [];

    if (search) {
      params.push(`search=${encodeURIComponent(search)}`);
    }
    if (perPage) {
      params.push(`per_page=${perPage}`);
    }
    if (pageNumber) {
      params.push(`page=${pageNumber}`);
    }

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return this.httpClient.get<any[]>(`${BASE_V2_URL}lysts/type/followed-listers${queryString}`);
  }

  getFollowedListersV2(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getFollowedListersV2Req(pageNumber, search, perPage).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data),
          });
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  private getMyLystsV2Req(
    pageNumber: number,
    filter: LystTypeFilter,
    search?: string,
    perPage?: number
  ): Observable<any> {
    const params = [];

    params.push(`filter=${filter}`);
    if (search) {
      params.push(`search=${encodeURIComponent(search)}`);
    }
    if (perPage) {
      params.push(`per_page=${perPage}`);
    }
    if (pageNumber) {
      params.push(`page=${pageNumber}`);
    }

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return this.httpClient.get<any[]>(`${BASE_V2_URL}lysts/type/my-lysts${queryString}`);
  }

  getMyLystsV2(
    pageNumber: number,
    filter: LystTypeFilter,
    search?: string,
    perPage?: number
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getMyLystsV2Req(pageNumber, filter, search, perPage).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data),
          });
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  private getRecommendedListersV2Req(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Observable<any> {
    const params = [];

    if (search) {
      params.push(`search=${encodeURIComponent(search)}`);
    }
    if (perPage) {
      params.push(`per_page=${perPage}`);
    }
    if (pageNumber) {
      params.push(`page=${pageNumber}`);
    }

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return this.httpClient.get<any[]>(`${BASE_V2_URL}lysts/type/recommended-listers${queryString}`);
  }

  getRecommendedListersV2(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getRecommendedListersV2Req(pageNumber, search, perPage).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data),
          });
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  private getRecommendedLystsV2Req(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Observable<any> {
    const params = [];

    if (search) {
      params.push(`search=${encodeURIComponent(search)}`);
    }
    if (perPage) {
      params.push(`per_page=${perPage}`);
    }
    if (pageNumber) {
      params.push(`page=${pageNumber}`);
    }

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return this.httpClient.get<any[]>(`${BASE_V2_URL}lysts/type/recommended-lysts${queryString}`);
  }

  getRecommendedLystsV2(
    pageNumber: number,
    search?: string,
    perPage?: number
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getRecommendedLystsV2Req(pageNumber, search, perPage).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data),
          });
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  // V2 ROUTES -> END

  private postListReq(bodyParams: any): Observable<any> {
    return this.httpClient.post(LISTS_API_ROUTES.POST_LIST, bodyParams) as any;
  }

  postList(bodyParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.postListReq(bodyParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private postListImageReq(urlParams: any, bodyParams: any): Observable<any> {
    const apiUrl = this.generalHelperService.replaceUrlParamsWithValues(LISTS_API_ROUTES.POST_LIST_IMAGE, urlParams);
    return this.httpClient.post(apiUrl, bodyParams) as any;
  }

  postListImage(urlParams: any, bodyParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.postListImageReq(urlParams, bodyParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private updateListReq(bodyParams: any, listId: number): Observable<any> {
    return this.httpClient.post(`lysts/${listId}`, bodyParams) as any;
  }

  updateList(bodyParams: any, listId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.updateListReq(bodyParams, listId).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private postListColumnReq(bodyParams: any, listId: number): Observable<any> {
    return this.httpClient.post(`lysts/${listId}/new_column`, bodyParams) as any;
  }

  postListColumn(bodyParams: any, listId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.postListColumnReq(bodyParams, listId).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private deleteListColumnReq(id: number | undefined): Observable<any> {
    return this.httpClient.delete<any>(`lysts/column/${id}`);
  }

  deleteListColumn(id: number | undefined): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.deleteListColumnReq(id).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private updateListColumnReq(id: number, reqObj: { name: string }): Observable<any> {
    return this.httpClient.post<any>(`lysts/rename_column/${id}`, reqObj);
  }

  updateListColumn(id: number, reqObj: { name: string }): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.updateListColumnReq(id, reqObj).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private deleteListReq(id: number): Observable<any> {
    return this.httpClient.delete<any>(`lysts/${id}`);
  }

  deleteList(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.deleteListReq(id).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }


  private deleteListItemReq(id: number): Observable<any> {
    return this.httpClient.delete<any>(`items/${id}/delete`);
  }

  deleteListItem(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.deleteListItemReq(id).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private reorderListsReq(body: { order: { id: number; order_value: number; }[] }): Observable<any> {
    return this.httpClient.post(`lysts/my_lysts/reorder`, body) as any;
  }

  reorderLists(body: { order: { id: number; order_value: number; }[] }): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.reorderListsReq(body).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private reorderListItemsReq(lyst_id: number, body: {
    order: { id: number; order_value: number; }[]
  }): Observable<any> {
    return this.httpClient.post(`lysts/${lyst_id}/lyst_items/reorder`, body) as any;
  }

  reorderListItems(lyst_id: number, body: { order: { id: number; order_value: number; }[] }): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.reorderListItemsReq(lyst_id, body).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getSingleListReq(listId: number, searchTerm?: string, filters?: {
    sort: string,
    id: number
  }): Observable<any> {
    let url = `${LISTS_API_ROUTES.GET_SINGLE_LIST}${listId}`;
    const params = [];
    if (searchTerm) {
      params.push(`search_keyword=${encodeURIComponent(searchTerm)}`);
    }
    if (filters) {
      params.push(`sort=${filters.sort}`);
      if (filters.id) {
        params.push(`lyst_attribute_id=${filters.id}`);
      }
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return this.httpClient.get(url) as any;
  }

  getSingleList(listId: number, searchTerm?: string, filters?: { sort: string, id: number }): Promise<ListInterface> {
    return new Promise<any>((resolve, reject) => {
      this.getSingleListReq(listId, searchTerm, filters).subscribe({
        next: (res: any) => {
          resolve(res.data);
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  private getPublicSingleListReq(urlParams: any, listId: number): Observable<any> {
    let apiUrl = this.generalHelperService.replaceUrlParamsWithValues(LISTS_API_ROUTES.GET_PUBLIC_SINGLE_LIST, {listId});
    apiUrl = this.generalHelperService.addUrlParams(apiUrl, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getPublicSingleList(urlParams: any, listId: number): Promise<ListInterface> {
    return new Promise<any>((resolve, reject) => {
      this.getPublicSingleListReq(urlParams, listId).subscribe({
        next: (res: any) => {
          resolve(res.data);
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  private getListPostsReq(listId: number, pageNum: number): Observable<any> {
    let url = `posts/lysts/${listId}`;
    const params = [];
    if (pageNum) {
      params.push(`page=${pageNum}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return this.httpClient.get<any[]>(url) as any;
  }

  getListPosts(listId: number, pageNum: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getListPostsReq(listId, pageNum).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data)
          });
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  private getItemPostsReq(item_id: number, pageNum: number): Observable<any> {
    let url = `posts/lyst_items/${item_id}`;
    const params = [];
    if (pageNum) {
      params.push(`page=${pageNum}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return this.httpClient.get<any[]>(url) as any;
  }

  getItemPosts(item_id: number, pageNum: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getItemPostsReq(item_id, pageNum).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data)
          });
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  private getListReviewsReq(listId: number, pageNum: number): Observable<any> {
    let url = `reviews/lysts/${listId}`;
    const params = [];
    if (pageNum) {
      params.push(`page=${pageNum}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return this.httpClient.get<any[]>(url) as any;
  }

  getListReviews(listId: number, pageNum: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getListReviewsReq(listId, pageNum).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data)
          });
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  private getItemReviewsReq(lyst_item_id: number, pageNum: number): Observable<any> {
    let url = `reviews/lyst_items/${lyst_item_id}`;
    const params = [];
    if (pageNum) {
      params.push(`page=${pageNum}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return this.httpClient.get<any[]>(url) as any;
  }

  getItemReviews(lyst_item_id: number, pageNum: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getItemReviewsReq(lyst_item_id, pageNum).subscribe({
        next: (res: any) => {
          resolve({
            data: res.data.data,
            pagination: this.generalHelperService.returnPagination(res.data)
          });
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  private getListLikesReq(listId: number | undefined, pageNum: number): Observable<any> {
    let url = `favorites/lysts/${listId}`;
    const params = [];
    if (pageNum) {
      params.push(`page=${pageNum}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return this.httpClient.get(url) as any;
  }

  getListLikes(listId: number | undefined, pageNum: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getListLikesReq(listId, pageNum).subscribe((res: any) => {
        resolve({
          data: res.data.data,
          pagination: this.generalHelperService.returnPagination(res.data)
        });
      }, error => {
        reject(error);
      });
    });
  }

  private getSingleItemReq(itemId: number): Observable<any> {
    return this.httpClient.get(`items/${itemId}`) as any;
  }

  getSingleItem(itemId: number): Promise<ListInterface> {
    return new Promise<any>((resolve, reject) => {
      this.getSingleItemReq(itemId).subscribe({
        next: (res: any) => {
          resolve(res.data);
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  private getPublicSingleItemReq(itemId: number): Observable<any> {
    return this.httpClient.get(`share/lyst_item/${itemId}`) as any;
  }

  getPublicSingleItem(itemId: number): Promise<ListInterface> {
    return new Promise<any>((resolve, reject) => {
      this.getPublicSingleItemReq(itemId).subscribe({
        next: (res: any) => {
          resolve(res.data);
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  private addListToFavoritesReq(listId: number): Observable<any> {
    return this.httpClient.post(`favorites/lysts/${listId}/toggle`, {}) as any;
  }

  addListToFavorites(userId: number): Promise<ListInterface> {
    return new Promise<any>((resolve, reject) => {
      this.addListToFavoritesReq(userId).subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  getLists() {
    return this.httpClient.get<any>('lysts');
  }

  toggleListVisibilty(listId: number) {
    return this.httpClient.post(`lysts/${listId}/toggle_visibility`, {});
  }

  print(listId: number) {
    return this.httpClient.get(`lysts/${listId}/print`, {responseType: 'blob'});
  }

  copyList(listId: number) {
    return this.httpClient.post(`lysts/${listId}/copy`, {});
  }

  copyListItem(listId: number, itemId: number | undefined) {
    return this.httpClient.post(`items/${itemId}/copy`, {lyst_id: listId});
  }

  private sendListReportReq(listId: number, bodyParams: any): Observable<any> {
    return this.httpClient.post(`reports/lysts/${listId}`, bodyParams) as any;
  }

  sendListReport(listId: number, bodyParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.sendListReportReq(listId, bodyParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  getSuggestedLists(listId: number): any {
    return this.httpClient.get(`lysts/${listId}/column_ideas`);
  }

  autopopulateList(listId: number): any {
    return this.httpClient.get(`lysts/${listId}/auto_populate`);
  }

  populateMissingData(listId: number): any {
    return this.httpClient.get(`lysts/${listId}/populate_missing`);
  }

  getAllListsForReorder(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getAllListsForReorderReq().subscribe((res: any) => {
        resolve({
          data: res.data
        });
      }, error => {
        reject(error);
      });
    });
  }

  private getAllListsForReorderReq(): Observable<any> {
    return this.httpClient.get('lysts/all_lysts/all_user_lysts') as any;
  }

  private getPublicSingleListItemReq(urlParams: any, listId: number): Observable<any> {
    let apiUrl = this.generalHelperService.replaceUrlParamsWithValues(LISTS_API_ROUTES.GET_PUBLIC_SINGLE_LIST_ITEMS, {listId});
    apiUrl = this.generalHelperService.addUrlParams(apiUrl, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }
  getPublicSingleListItem(urlParams: any, listId: number): Promise<ListItemInterface> {
    return new Promise<any>((resolve, reject) => {
      this.getPublicSingleListItemReq(urlParams, listId).subscribe({
        next: (res: any) => {
          resolve(res.data);
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }
}
